import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Table,
  Row,
  Card,
  Input,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { FolderOpenOutlined } from '@ant-design/icons';

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import TextArea from 'antd/es/input/TextArea';
import appStatic from '../../../../../../config/appStatic';
import styles from '../../../../../../assets/styles/styles';


const columns = [

  {
    title: '',
    children: [
      {
        title: "Date",
        dataIndex: "date",
      }
    ]
  },
  {
    title: 'Loan Amount and Balance',
    children: [
      {
        title: "Principal Due",
        dataIndex: "principalDue",
      },
      {
        title: "Balance Of Loan",
        dataIndex: "balanceOfLoan",
      },
    ]
  },
  {
    title: 'Total Cost of Loan',
    children: [
      {
        title: "Interest",
        dataIndex: "interest",
      },
      {
        title: "Fees",
        dataIndex: "fees",
      },
      {
        title: "Penalties",
        dataIndex: "penalties",
      },
    ]
  },

  {
    title: 'Installment Totals',
    children: [
      {
        title: "Due",
        dataIndex: "due",
      },
      {
        title: "Oustanding",
        dataIndex: "outstanding",
      },
    ]
  },
  {
    title: 'Installment Totals',
    children: [
      {
        title: "Due",
        dataIndex: "due",
      },
      {
        title: "Oustanding",
        dataIndex: "outstanding",
      },
    ]
  },

];

const ReschedulePreview = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { monthList } = appStatic
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [rescheduleReasons, setRescheduleReasons] = useState([]);
  const [rescheduleRequestTemplate, setRescheduleRequestTemplate] = useState([]);
  const [newRepaymentSchedule, setNewRepaymentSchedule] = useState([]);
  const [showRepaymentSchedule, setShowRepaymentSchedule] = useState(false);
  const childref = useRef();
  const rejChildref = useRef();

  useEffect(() => {
    getDetail();
  }, []);

  function getDetail() {
    const url = `${apiConfig.RescheduleLoans}/${state.resourceId}`
    const params = {
      command: "previewLoanReschedule",
    }
    let body = {
      session,
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false)
        const objList = res;
        setRescheduleRequestTemplate(objList)

        let tempLoanTermsData = []

        objList?.loanTermVariationsData?.forEach((element) =>
          tempLoanTermsData.push({
            id: element?.id,
            value: element?.decimalValue ? element.decimalValue : "-",
            dateValue: element?.dateValue ? element.dateValue : "-",
          })
        )
        setRescheduleReasons(tempLoanTermsData)

        BOM.HasPermission("APPROVERESCHEDULE_LOAN") && dispatch({ type: cnt.RIGHT_APPROVE_BTN });
        BOM.HasPermission("REJECTRESCHEDULE_LOAN") && dispatch({ type: cnt.RIGHT_REJECT_BTN });

      }
    });
  }

  function getTemplate() {

    const params = {
      command: "previewLoanReschedule"
    }

    const url = `${apiConfig.RescheduleLoans}/${state.resourceId}`

    let body = {
      session,
      params
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false)
        const objList = res;

        let tempNewRepaymentSchedule = [];

        objList?.periods?.forEach((element) => {
          tempNewRepaymentSchedule.push({
            key: element?.id,
            id: element?.id,
            date: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            paidDate: element?.fromDate
              ? BOM.DateTime(element?.fromDate, "only-date")
              : "-",
            days: element?.daysInPeriod ? element?.daysInPeriod : "-",
            principalDue: element?.principalDue ? element?.principalDue : "-",
            balanceOfLoan: element?.principalLoanBalanceOutstanding
              ? element?.principalLoanBalanceOutstanding
              : "-",
            interest: element?.interestDue ? element?.interestDue : "-",
            fees: element?.feeChargesDue
              ? element?.feeChargesDue
              : element?.feeChargesDue === 0
                ? "0"
                : "-",
            penalties: element?.penaltyChargesDue
              ? element?.penaltyChargesDue
              : element?.penaltyChargesDue === 0
                ? "0"
                : "-",
            due: element?.totalDueForPeriod
              ? element?.totalDueForPeriod
              : element?.totalDueForPeriod === 0
                ? "0"
                : "-",
            paid: element?.principalPaid
              ? element?.principalPaid
              : element?.principalPaid === 0
                ? "0"
                : "-",
            inAdvance: element?.totalPaidInAdvanceForPeriod
              ? element?.totalPaidInAdvanceForPeriod
              : element?.totalPaidInAdvanceForPeriod === 0
                ? "0"
                : "-",
            late: element?.totalPaidLateForPeriod
              ? element?.totalPaidLateForPeriod
              : element?.totalPaidLateForPeriod === 0
                ? "0"
                : "-",
            outstanding: element?.totalOutstandingForPeriod
              ? element?.totalOutstandingForPeriod
              : "-",
          });
        });

        form.setFieldsValue({
          totalPrincipalDue: objList?.totalPrincipalExpected,
          totalFees: objList?.totalFeeChargesCharged,
          totalInterest: objList?.totalInterestCharged,
          totalOutstanding: objList?.totalRepaymentExpected,
          totalPenalties: objList?.totalPenaltyChargesCharged,
        })
        setNewRepaymentSchedule(tempNewRepaymentSchedule)
      }
    });
  }

  function onCancel() {
    navigate("/detail-child-glim", { state: state });
  }

  function handleShowRepaymentSchedule() {
    switch (showRepaymentSchedule) {
      case false:
        setShowRepaymentSchedule(true)
        break;
      case true:
        setShowRepaymentSchedule(false)
      default:
        break;
    }
    getTemplate()
  }

  function handleOnActivateApprove() {
    childref?.current?.showModal();
  }

  function handleOnActivateReject() {
    rejChildref?.current?.showModal();
  }

  const onSubmit = (formValues) => {

    formValues.rescheduleFromDate = BOM.DateTime(formValues.rescheduleFromDate, "only-date")
    formValues.adjustedDueDate = BOM.DateTime(formValues.adjustedDueDate, "only-date")
    formValues.submittedOnDate = BOM.DateTime(formValues.submittedOnDate, "only-date")

    formValues.loanId = state.id

    delete formValues.newFixedPrincipalPercentagePerInstallment

    const params = {
      command: "reschedule"
    }
    const url = `${apiConfig.RescheduleLoans}`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.rescheduleMsg);
        navigate("/detail-group-loan", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const items = [
    {
      label: labelConfig.rescheduleFromInstallment,
      children: rescheduleRequestTemplate?.rescheduleFromDate
        ? (`${rescheduleRequestTemplate?.rescheduleFromDate[2]} ${monthList[rescheduleRequestTemplate?.rescheduleFromDate[1] - 1]} ${rescheduleRequestTemplate?.rescheduleFromDate[0]}`)
        : "-"
    },
    {
      label: labelConfig.reasonForRescheduling,
      children: rescheduleRequestTemplate?.rescheduleReasonCodeValue?.name
    },
    {
      label: labelConfig.submittedOn,
      children: rescheduleRequestTemplate?.timeline?.submittedOnDate
        ? (`${rescheduleRequestTemplate?.timeline?.submittedOnDate[2]} ${monthList[rescheduleRequestTemplate?.timeline?.submittedOnDate[1] - 1]} ${rescheduleRequestTemplate?.timeline?.submittedOnDate[0]}`)
        : "-"
    },
    {
      label: labelConfig.installmentRescheduledTo,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "dueDate") ? BOM.DateTime(rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "dueDate").dateValue, "only-date") : "-"
    },
    {
      label: labelConfig.introduceGracePeriod,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "introduceGracePeriod") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "introduceGracePeriod")?.decimalValue : "-"
    },
    {
      label: labelConfig.principalGracePeriods,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "graceOnPrincipal") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "graceOnPrincipal")?.decimalValue : "-"
    },
    {
      label: labelConfig.interestGracePeriods,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "graceOnInterest") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "graceOnInterest")?.decimalValue : "-"
    },
    {
      label: labelConfig.changeRepaymentDate,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "changeRepaymentDate") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "changeRepaymentDate")?.decimalValue : "-"
    },
    {
      label: labelConfig.extendRepaymentPeriod,
      children: "-"
    },
    {
      label: labelConfig.numberOfNewRepayments,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "extendRepaymentPeriod") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "extendRepaymentPeriod")?.decimalValue : "-"
    },
    {
      label: labelConfig.adjustInterestRates,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "adjustInterestRates") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "adjustInterestRates")?.decimalValue : "-"
    },
    {
      label: labelConfig.newInterestRates,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "interestRateForInstallment") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "interestRateForInstallment")?.decimalValue : "-"
    },
    {
      label: labelConfig.changeFixedPrincipal,
      children: rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "changeFixedPrincipal") ? rescheduleRequestTemplate?.loanTermVariationsData?.find((item) => item?.termType?.value === "changeFixedPrincipal")?.decimalValue : "-"
    },
  ];

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => handleOnActivateApprove()}
      onReject={() => handleOnActivateReject()}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.rescheduleRequest}
        pageItems={staticConfig.rescheduleRequestBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >

              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Row>

            <Row>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.comment}
                  name={"comment"}
                >
                  <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please enter a comment' />

                </Form.Item>
              </Col>

              <Divider orientation="left"></Divider>
              <Button
                type="primary"
                icon={<FolderOpenOutlined />}
                shape='round'
                style={{
                  backgroundColor: "#92428B",
                  color: "white",
                  marginTop: 30,
                }}
                onClick={handleShowRepaymentSchedule}
              >
                {showRepaymentSchedule === false ? labelConfig.viewRepaymentSchedule : labelConfig.hideRepaymentSchedule}
              </Button>

              {
                showRepaymentSchedule === true ?

                  <>
                    <Col span={24} style={{ padding: "0px 8px" }}>
                      <Table
                        columns={columns}
                        dataSource={newRepaymentSchedule}
                      ></Table>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.totalPrincipalDue}
                        name="totalPrincipalDue"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.totalInterest}
                        name="totalInterest"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.totalFees}
                        name="totalFees"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.totalPenalties}
                        name="totalPenalties"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.totalOutstanding}
                        name="totalOutstanding"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </>
                  : null
              }

            </Row>

            <Row>
              <Divider />
              <ApproveModal
                session={session}
                state={state}
                navigate={navigate}
                ref={childref}
                userData={userData}
              />
              <RejectModal
                session={session}
                state={state}
                navigate={navigate}
                ref={rejChildref}
                userData={userData}
              />
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>

    </MainLayout>

  )
}

export default ReschedulePreview

const ApproveModal = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const { currentCustomerObj, userData, state } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const params = {
      command: "approve"
    }

    const url = `${apiConfig.RescheduleLoans}/${state.resourceId}`

    formValues.approvedOnDate = BOM.DateTime(formValues.approvedOnDate, "only-date");

    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveRescheduleMsg);

        navigate("/detail-child-glim", { state: state });
        // close modal
        setIsModalOpen(false);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Modal
        title="Approve Loan Reschedule"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          disabled: !BOM.HasPermission("APPROVERESCHEDULE_LOAN"),
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left"></Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.approvedOn}
                name="approvedOnDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.approvedOn),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
});

const RejectModal = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const { currentCustomerObj, userData, state } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const params = {
      command: "reject"
    }

    const url = `${apiConfig.RescheduleLoans}/${state.resourceId}`

    formValues.rejectedOnDate = BOM.DateTime(formValues.rejectedOnDate, "only-date");

    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectRescheduleMsg);

        navigate("/detail-group-loan", { state: state });
        // close modal
        setIsModalOpen(false);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Modal
        title="Reject Loan Reschedule"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          disabled: !BOM.HasPermission("REJECTRESCHEDULE_LOAN"),
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left"></Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.rejectedOn}
                name="rejectedOnDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.rejectedOn),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
});